
import axios from 'axios';
import {useState,useEffect} from 'react';
import { isDev,isWechat } from '../utils';

const Scanner = ({url,callBack = ()=>{}})=>{
    const wx = window.wx;
    const [ready,setReady] = useState(false);

    const [show,setShow]   = useState(true);

    wx.checkJsApi({
          
          jsApiList: [
            'scanQRCode',
            'chooseWXPay'
          ], // 需要检测的JS接口列表，所有JS接口列表见附录2,
          
          success: function(res) {
              // 以键值对的形式返回，可用的api值true，不可用为false
              // 如：{"checkResult":{"chooseImage":true},"errMsg":"checkJsApi:ok"}
              // ['scanQRCode','chooseWXPay']
            

              if(res.checkResult.scanQRCode !== true)
              {
                  setShow(false);
              }
          }
      });
    //  console.log('wx',wx);
    //  console.log(url);
     useEffect(()=>{
        (async()=>{

            try {

             if(ready || !isWechat()) return;

            //   const endPoint = 'https://www.eparts.cn/collaboarates/wechat_jssdk';

              const URL = isDev() 
                ? 'http://localhost:4000/api/wechat_config' 
                : 'https://service.eparts.cn/api/wechat_config';

              //post the url to backend
              const {data} = await axios.post(URL,{url},{
                 headers : {
                    'Content-Type':'application/json'
                    // Authorization: `Bearer ${ userInfo.token }`
                 }
              });
              
              wx.config({
                ...data,
                debug: false,//true,//false,//false,//true,//false,//true, // 开启调试模式
              // 必填，签名，见附录1
                jsApiList: [
                  'scanQRCode',
                  'chooseWXPay',
                  // 'openLocation'
                ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
              });

              setReady(true);

            } catch(error){
                console.log(error.message);
 
            }
        })();

        return ()=>{}
     },[url,wx,ready]);

     const clickHandler =(e)=>{
         
         if(!ready || !isWechat()) return;

         e.target.blur();
         
         wx.scanQRCode({
            needResult: 1, // 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
            scanType: ["barCode",'qrCode',"pdf417"], // "qrCode", 可以指定扫二维码还是一维码，默认二者都有
            success: function (res) {  
               let result = res.resultStr; // 当needResult 为 1 时，扫码返回的结果
              //  alert(result);
               callBack(result.split(',')[1]);
             

            }
        });      
     };

    /*
           $('.btn2').click(function () {
            wx.openLocation({
                latitude: 22.545538, // 纬度，浮点数，范围为90 ~ -90
                longitude: 114.054565, // 经度，浮点数，范围为180 ~ -180。
                name: '这里填写位置名', // 位置名
                address: '位置名的详情说明', // 地址详情说明
                scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为最大
            });
          })
    */

    return (
        <>
         {ready && isWechat() && show && (<span 
            className='btn btn-sm btn-outline-danger text-white rounded'
            onClick = {clickHandler}
         >
         <i 
           className='fa fa-barcode text-danger'
           style = {{fontSize:'125%'}}
         
         ></i>
         </span>)}
        </>
       
    );
}

export default Scanner;